import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation, useQueryClient } from "react-query";

const useUpdateVesselInformation = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const updateVesselInformation = async ({vesselId, updatedInfo}) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/vessel/update/vesselInformation/${vesselId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(updatedInfo),
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message || "Failed to update vessel information");
      }

      return response.json();
    } catch (error) {
      throw new Error(error.message || "Failed to update vessel information");
    }
  };

  return useMutation(updateVesselInformation, {
    onSuccess: () => {
      queryClient.invalidateQueries("vessels");
    },
    onError: (error) => {
      console.error("Error updating primary information:", error);
    },
  });

};

export default useUpdateVesselInformation;
